import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { I18nProvider } from "./lib/i18n";
import { AuthProvider } from "./lib/auth";
import { FavoritesProvider } from "./lib/favorites";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Marketplace from "./pages/Marketplace";
import NewListing from "./pages/NewListing";
import ListingDetail from "./pages/ListingDetail";
import Dashboard from "./pages/Dashboard";
import Messages from "./pages/Messages";
import Favorites from "./pages/Favorites";
import Profile from "./pages/Profile";
import ProviderBookings from "./pages/ProviderBookings";
import MyBookings from "./pages/MyBookings";
import BookProvider from "./pages/BookProvider";
import ReviewsInbox from "./pages/ReviewsInbox";
import Horses from "./pages/Horses";
import Rentals from "./pages/Rentals";
import AdminFeedback from "./pages/AdminFeedback";
import Privacy from "./pages/Privacy";
import CookieBanner from "./components/CookieBanner";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";

function Shell({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-[#FAFAFA]">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <FavoritesProvider>
          <BrowserRouter>
            <Toaster position="top-right" richColors />
            <Shell>
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/marketplace" element={<Marketplace />} />
                <Route path="/new" element={<NewListing />} />
                <Route path="/listings/:id" element={<ListingDetail />} />
                <Route path="/listings/:id/edit" element={<NewListing />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/messages" element={<Messages />} />
                <Route path="/favorites" element={<Favorites />} />
                <Route path="/users/:id" element={<Profile />} />
                <Route path="/bookings/provider" element={<ProviderBookings />} />
                <Route path="/bookings/mine" element={<MyBookings />} />
                <Route path="/providers/:id/book" element={<BookProvider />} />
                <Route path="/reviews/inbox" element={<ReviewsInbox />} />
                <Route path="/horses" element={<Horses />} />
                <Route path="/rentals" element={<Rentals />} />
                <Route path="/admin/feedback" element={<AdminFeedback />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
              </Routes>
            </Shell>
            <CookieBanner />
          </BrowserRouter>
        </FavoritesProvider>
      </AuthProvider>
    </I18nProvider>
  );
}
